import { Dispatch, SetStateAction } from 'react'
import { messageTypeByFileType } from '$func/file'
import { ImagePreviewTypes, VideoPreviewTypes } from '../../send-field.type'
import { FilePreview } from './file-preview'
import { ImagePreview } from './image-preview'
import { VideoPreview } from './video-preview'
import { AudioPreview } from './audio-preview'

export function UploadPreview({
  file,
  onCancel,
  hasBorder,
  imagePreviewMode,
  videoPreviewMode,
  setImagePreviewMode,
  setVideoPreviewMode,
  setFile,
  setVideoCompressionHeight,
  videoCompressionHeight,
}: {
  file: File
  onCancel: () => unknown
  hasBorder: boolean
  imagePreviewMode: ImagePreviewTypes
  videoPreviewMode: VideoPreviewTypes
  setImagePreviewMode: Dispatch<SetStateAction<ImagePreviewTypes>>
  setVideoPreviewMode: Dispatch<SetStateAction<VideoPreviewTypes>>
  setFile: (newFile: File) => unknown
  setVideoCompressionHeight: (height: number) => unknown
  videoCompressionHeight?: number
}) {
  if (messageTypeByFileType(file.type) === 'IMAGE')
    return (
      <ImagePreview
        file={file}
        onCancel={onCancel}
        imagePreviewMode={imagePreviewMode}
        setImagePreviewMode={setImagePreviewMode}
        setFile={setFile}
      />
    )

  if (messageTypeByFileType(file.type) === 'VIDEO')
    return (
      <VideoPreview
        file={file}
        onCancel={onCancel}
        videoPreviewMode={videoPreviewMode}
        setVideoPreviewMode={setVideoPreviewMode}
        setVideoCompressionHeight={setVideoCompressionHeight}
        compressionHeight={videoCompressionHeight}
      />
    )

  if (messageTypeByFileType(file.type) === 'AUDIO')
    return (
      <AudioPreview file={file} onCancel={onCancel} hasBorder={hasBorder} />
    )

  return <FilePreview file={file} onCancel={onCancel} hasBorder={hasBorder} />
}
